export const VERSION = "0.0.0";

// Pluggable interface contracts — Asset Kind Provider
export type {
  AssetKindFileFilter,
  AssetKindRequiresEdge,
  IAssetKindProvider,
} from "./asset-kind-provider.js";
export type { IAssetKindRegistry } from "./asset-kind-registry.js";
// Pluggable interface contracts — Asset Kind Registry
export {
  AssetKindConflictError,
  AssetKindPathAmbiguityError,
  AssetKindPatternConflictError,
  AssetKindRegistryFrozenError,
} from "./asset-kind-registry.js";
// Pluggable interface contracts — Catalog Source
export type {
  CatalogAsset,
  CatalogAssetFilter,
  CatalogDomain,
  CatalogDomainFilter,
  CatalogSourceInfo,
  DomainRelation,
  ICatalogSource,
} from "./catalog-source.js";

export type {
  ISecretsProvider,
  ListFilter,
  ProviderCapabilities,
  SecretMetadata,
  SetSecretOptions,
} from "./secrets-provider.js";
// Pluggable interface contracts — Secrets
export {
  ProviderUnavailableError,
  SecretAccessDeniedError,
  SecretExpiredError,
  SecretNotFoundError,
  SecretsError,
} from "./secrets-provider.js";
